import { useState, useEffect } from 'react';

const useScreenHeight = () => {
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const debounce = (func: (...args: any[]) => void, wait: number) => {
      let timeout: any;
      return (...args: any[]) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    };

    const handleResize = debounce(() => {
      setHeight(window.innerHeight);
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return height;
};

export default useScreenHeight;
